import React from 'react';
import PropTypes from 'prop-types';

const ChevronRight = ({ theme, fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99999 21C7.1161 21.1164 7.25404 21.2088 7.4059 21.2718C7.55777 21.3348 7.72057 21.3672 7.88499 21.3672C8.04941 21.3672 8.21221 21.3348 8.36407 21.2718C8.51593 21.2088 8.65387 21.1164 8.76999 21L17.08 12.7C17.2632 12.5131 17.3658 12.2618 17.3658 12C17.3658 11.7383 17.2632 11.4869 17.08 11.3L8.76999 3.00001C8.66176 2.85607 8.52393 2.737 8.36579 2.65083C8.20765 2.56467 8.03287 2.5134 7.85325 2.50049C7.67362 2.48757 7.49331 2.51332 7.32447 2.57599C7.15563 2.63865 7.00219 2.73678 6.87449 2.86377C6.74678 2.99075 6.64778 3.14363 6.58416 3.31211C6.52054 3.48059 6.49377 3.66075 6.50566 3.84045C6.51756 4.02015 6.56783 4.19521 6.65311 4.35384C6.73838 4.51246 6.85666 4.65097 6.99999 4.76001L14.24 12L6.99999 19.26C6.77395 19.4932 6.64754 19.8052 6.64754 20.13C6.64754 20.4548 6.77394 20.7668 6.99999 21Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

ChevronRight.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default ChevronRight;
